import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import IQVIASearchBar from '../components/IQVIA/IQVIASearchBar';
import MarketVolumeChart from '../components/IQVIA/MarketVolumeChart';
import StrengthAnalysis from '../components/IQVIA/StrengthAnalysis';
import ChannelAnalysis from '../components/IQVIA/ChannelAnalysis';
import PriceIntelligence from '../components/IQVIA/PriceIntelligence';

const { FiBarChart3, FiTrendingUp, FiSearch } = FiIcons;

const IQVIADashboard = () => {
  const [selectedProduct, setSelectedProduct] = useState('Abiraterone Acetate');

  const handleProductSearch = (productName) => {
    setSelectedProduct(productName);
  };

  return (
    <div className="space-y-8">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-r from-indigo-600 to-purple-700 rounded-2xl p-8 text-white"
      >
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold mb-2 flex items-center gap-3">
              <SafeIcon icon={FiBarChart3} className="text-4xl" />
              IQVIA Market Intelligence
            </h1>
            <p className="text-indigo-100 text-lg">
              Comprehensive market data and competitive intelligence for generic pharmaceuticals
            </p>
          </div>
          <div className="hidden md:block">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <p className="text-sm text-indigo-100 mb-1">Data Source</p>
              <p className="font-semibold">IQVIA Market Analytics</p>
              <p className="text-xs text-indigo-200">USA Generic Market</p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Search Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
      >
        <div className="flex items-center gap-3 mb-4">
          <SafeIcon icon={FiSearch} className="text-blue-600 text-xl" />
          <h2 className="text-lg font-semibold text-gray-900">Product Search</h2>
        </div>
        <IQVIASearchBar onProductSelect={handleProductSearch} selectedProduct={selectedProduct} />
      </motion.div>

      {/* Market Volume Trends */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <MarketVolumeChart selectedProduct={selectedProduct} />
      </motion.div>

      {/* Strength & SKU Analysis */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <StrengthAnalysis selectedProduct={selectedProduct} />
      </motion.div>

      {/* Channel Analysis */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <ChannelAnalysis selectedProduct={selectedProduct} />
      </motion.div>

      {/* NSP and WAC Price Intelligence */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        <PriceIntelligence selectedProduct={selectedProduct} />
      </motion.div>
    </div>
  );
};

export default IQVIADashboard;